import {
  FilterOptionList,
  type FilterOption,
} from '@/components/ui/filter-option-list';
import { FilterPopoverTrigger } from '@/components/ui/filter-popover-trigger';
import { Compass, Gem, Rss, Shield } from 'lucide-react';
import { type FC } from 'react';

export const TYPE_LABELS: Record<string, string> = {
  guidance: 'Guidance',
  standard: 'Standard',
  regulation: 'Regulation',
  news: 'News',
  unknown: 'Unknown',
};

export const DOCUMENT_TYPE_FILTER_OPTIONS: FilterOption[] = [
  { label: 'Regulation', value: 'regulation' },
  { label: 'Guidance', value: 'guidance' },
  { label: 'Standard', value: 'standard' },
  { label: 'News', value: 'news' },
];

export const TYPE_BADGE_CONFIG: Record<
  string,
  { icon: FC<{ className?: string }>; bgClass: string }
> = {
  regulation: { icon: Shield, bgClass: 'bg-magenta-100' },
  guidance: { icon: Compass, bgClass: 'bg-purple-100' },
  standard: { icon: Gem, bgClass: 'bg-orange-100' },
  news: { icon: Rss, bgClass: 'bg-blue-100' },
};

export const OptionFilter: FC<{
  label: string;
  options: FilterOption[];
  selected: string[];
  onChange: (selected: string[]) => void;
}> = ({ label, options, selected, onChange }) => {
  const isActive = selected.length > 0;
  const activeLabel =
    selected.length === 1
      ? options.find(o => o.value === selected[0])?.label
      : `${selected.length} selected`;

  return (
    <FilterPopoverTrigger
      label={label}
      isActive={isActive}
      operator={
        isActive ? (selected.length === 1 ? 'is' : 'is any of') : undefined
      }
      activeContent={isActive ? activeLabel : undefined}
      onClear={isActive ? () => onChange([]) : undefined}
    >
      <FilterOptionList
        options={options}
        selected={selected}
        onChange={onChange}
        showSearch={false}
      />
    </FilterPopoverTrigger>
  );
};
